module.exports = __webpack_public_path__ + "img/16131231008.FTI.f300e3ca.svg";